
export const LOAD_ENUM_DATA_IN_PROGRESS = "LOAD_ENUM_DATA_IN_PROGRESS";
export const loadEnumDataInProgress = () => ({
  type: LOAD_ENUM_DATA_IN_PROGRESS,
});

export const LOAD_ENUM_DATA_SUCCESS = "LOAD_ENUM_DATA_SUCCESS";
export const loadEnumDataSuccess = (data) => ({
  type: LOAD_ENUM_DATA_SUCCESS,
  payload: { data },
});

export const LOAD_ENUM_DATA_FAILURE = "LOAD_ENUM_DATA_FAILURE";
export const loadEnumDataFailure = () => ({
  type: LOAD_ENUM_DATA_FAILURE,
});

export const OPEN_ENUMS_DIALOG = "OPEN_ENUMS_DIALOG";
export const openEnumsDialog = () => ({
  type: OPEN_ENUMS_DIALOG,
});

export const CLOSE_ENUMS_DIALOG = "CLOSE_ENUMS_DIALOG";
export const closeEnumsDialog = () => ({
  type: CLOSE_ENUMS_DIALOG,
});

export const LOAD_ENUM_SINGLE_DATA = "LOAD_ENUM_SINGLE_DATA";
export const loadEnumSingleData = (data) => ({
  type: LOAD_ENUM_SINGLE_DATA,
  payload: { data },
});

export const ENUM_OPERATION_COMPLETED = "ENUM_OPERATION_COMPLETED";
export const enumOperationCompleted = () => ({
  type: ENUM_OPERATION_COMPLETED,
});